import { CommonModule } from '@angular/common';
import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lZero',
    standalone: false
})
export class LeadingZeroPipe implements PipeTransform {

    transform(value: any): any {
        if (value === undefined || value === null) {
            value = 0;
        }
        return (value < 10 ? '0' : '') + value;
    }

}

@NgModule({
    imports: [CommonModule],
    declarations: [LeadingZeroPipe],
    exports: [LeadingZeroPipe]
})
export class LeadingZeroPipeModule { }

